module.exports = __webpack_public_path__ + "img/PillCtrls.e5089411.jpg";